// assets/share-button.js

document.addEventListener('DOMContentLoaded', () => {
  const id       = 'sharebtn';
  const btn      = document.querySelector(`.ai-share-button-${id}`);
  const overlay  = document.querySelector(`.ai-share-overlay-${id}`);
  const panel    = document.querySelector(`.ai-share-panel-${id}`);
  const closeBtn = document.querySelector(`.ai-share-panel-close-${id}`);
  const copyBtn  = document.querySelector(`.ai-share-copy-link-${id}`);
  const feedback = document.querySelector(`.ai-share-feedback-${id}`);
  const options  = document.querySelectorAll(`.ai-share-option-${id}`);

  if (!btn || !panel || !overlay) return;

  // Share button click
  btn.addEventListener('click', async (e) => {
    e.preventDefault();

    const shareData = {
      title: document.title,
      text: 'Check out this product!',
      url: window.location.href
    };

    // If Web Share API available
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        // success—nothing more to do
        return;
      } catch (err) {
        // either user cancelled or error → fallback
        if (err.name !== 'AbortError') {
          openPanel();
        }
      }
    } else {
      // API not supported → fallback
      openPanel();
    }
  });

  // Function to open our custom panel
  function openPanel() {
    overlay.classList.add('active');
    panel.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  // Close panel helper
  function closePanel() {
    overlay.classList.remove('active');
    panel.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Close via close-button or overlay click
  closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);

  // Copy link action
  copyBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      feedback.classList.add('active');
      setTimeout(() => feedback.classList.remove('active'), 2000);
    });
  });

  // Custom share options (Facebook, Twitter, Email…)
  options.forEach(opt => {
    opt.addEventListener('click', (e) => {
      e.preventDefault();
      const platform = opt.getAttribute('data-platform');
      const pageUrl  = encodeURIComponent(window.location.href);
      let shareUrl   = '';

      switch (platform) {
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
          break;
        case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareData.text)}&url=${pageUrl}`;
          break;
        case 'email':
          shareUrl = `mailto:?subject=${encodeURIComponent(shareData.title)}&body=${encodeURIComponent(shareData.text + ' ' + window.location.href)}`;
          break;
      }

      if (shareUrl) {
        window.open(shareUrl, '_blank');
        closePanel();
      }
    });
  });
});
